// components/RegionAutoComplete.jsx

import AsyncSelect from "react-select/async";
import { getRegionAutoComplete } from "app/services/RegionService";

function RegionAutoComplete({
  value,
  onChange,
  placeholder = "Search Region",
  isDisabled = false,
  name = "region",
}) {
  // load options only when typing
  const loadRegionOptions = async (inputValue) => {
    try {
      // prevent api call on refresh/open
      if (!inputValue || inputValue.trim().length < 1) {
        return [];
      }
      debugger;
      const response = await getRegionAutoComplete(inputValue);

      const options = (response?.data || []).map((item) => ({
        id: item.id,
        label: item.name,
      }));

      return options;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions={false}
      defaultOptions={false} // prevent auto api call
      value={value}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadRegionOptions}
      onChange={onChange}
      name={name}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isClearable
      noOptionsMessage={({ inputValue }) =>
        !inputValue ? "Type to search region" : "No region found"
      }
      loadingMessage={() => "Searching..."}
    />
  );
}

export default RegionAutoComplete;
